<template>
    <div class="content">
        <div class="card card-default">
            <div class="card-header">
                <h3 class="card-title">
                    <router-link to="/admin/report" size="sm" class="" title="Phân quyền Report">
                        <i class="fa-solid fa-arrow-left"></i>
                    </router-link>
                </h3>
                <div class="card-tools">
                    <button type="button" class="btn btn-tool" @click="getData" title="Tải lại">
                        <i class="fas fa-arrows-rotate"></i>
                    </button>
                    <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Thu gọn">
                        <i class="fas fa-minus"></i>
                    </button>
                    <button type="button" class="btn btn-tool" data-card-widget="remove" title="Ẩn">
                        <i class="fas fa-times"></i>
                    </button>

                </div>
            </div>
            <!-- /.card-header -->
            <div class="card-body">
                <div class="row mb-2">
                    <div class="col-md-3 mb-3">
                        
                    </div>
                    <div class="col-md-6 text-center">
                        <button type="button" class="btn btn-success" @click="showConfirmModal()" :disabled="submitted">
                            <span v-if="submitted" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Cập nhật dữ liệu
                        </button>
                    </div>
                    <div class="col-md-3">
                        <!-- <div class="input-group mb-3">
                            <input type="text" class="form-control" placeholder="Nhập  từ khóa tìm kiếm" v-model="filter">
                            <div class="input-group-append">
                                <span class="input-group-text" @click="onSearchKey" role="button">
                                    <i class="fas fa-search"></i>
                                </span>
                            </div>
                        </div> -->
                        <select id="reportOptions" class="form-control d-inline" style="width: 100%" v-model="selectedReportId" @change="getRoleReport()">
                            <option v-for="item in reportOptions" :value="item.id" :key="item.id" :selected="selectedReportId">{{ item.reportName }}</option>
                        </select>
                    </div>
                </div>
                <div class="table-responsive p-0">
                    <!-- loading overlay -->
                    <loading :active="isBusy" class="text-center" color="#000000" loader="spinner"></loading>
                    <!-- table data -->
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th class="col5">#</th>
                                <th>Quyền</th>
                                <th class="col5">
                                    <div class="custom-control custom-checkbox">
                                        <input class="custom-control-input" type="checkbox" id="checkboxAll"
                                            @click="selectAllRows($event)">
                                        <label for="checkboxAll" class="custom-control-label"></label>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in items" :key="item.id">
                                <td style="vertical-align: middle !important;">{{ item.rowNumber }}</td>
                                <td style="vertical-align: middle;">{{ item.ten }}</td>
                                <td @click="selectRow(item.id)" style="cursor: pointer; vertical-align: middle;" title="Chọn item">
                                    <span v-if="(selected.includes(item.id))" aria-hidden="true" class="text-primary">&check;</span>
                                    <span v-else aria-hidden="true">&nbsp;</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <!-- CONFIRM MODAL -->
        <div class="modal fade" id="confirmModal" data-keyboard="false" data-backdrop="static">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-danger">Xác nhận</h4>
                        <button type="button" class="close" aria-label="Close" @click="hideConfirmModal()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <label>Lưu lại thay đổi?</label>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-outline-dark pull-left" @click="hideConfirmModal()">&nbsp;Đóng</button>
                        <button type="button" class="btn btn-outline-success pull-right" @click="onSubmit();" :disabled="submitted">
                            <span v-if="submitted" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Đồng ý
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import $ from 'jquery'
import { mapActions } from 'vuex'
import config from '@/config/prod.env';
import Paginate from "vuejs-paginate-next";
import Loading from "vue3-loading-overlay";
import TheSelect from '@/components/shared/UserInput/TheSelect.vue';
export default {
    components: {
        loading: Loading,
    },
    name: "TheReport",
    data() {
        return {
            isBusy: false,
            streamFileUrl: `${process.env.VUE_APP_API_URL}/Common/StreamFile?url=`,
            // table
            filter: null,
            items: [],
            numberOfShow: 0,
            storedRoleIds: [],
            deleteRoleIds: [],
            createRoleIds: [],

            reportOptions: [],
            selectedReportId: null,

            // For mesage validate
            errors: {},
            submitted: false,
            selected: [],
            rowSelected: null,
            isUpdate: false
        }
    },
    methods: {
        // Map action
        ...mapActions('header', ['setupHeader',]),
        ...mapActions('role', ['getAllRole']),
        ...mapActions('roleReport', ['getByReportIdAndRoleIds', 'createRoleReportMultiple', 'deleteByReportIdAndRoleIds']),
        ...mapActions('report', ['getActiveReportByWorkspaceId']),
        ...mapActions('alert', ['warning',]),
        // setup
        async setup() {
            //setup dynamic header
            let header = 'Phân quyền Report';
            this.setupHeader({ header });      
        },

        // ------ get data datatable ------
        async getRoleReport() {
            alert('me')
            // get role report by report and role ids
            let roleIds = await Promise.all(this.items.map(e => e.id));
            let res2 = await this.getByReportIdAndRoleIds({
                reportId: this.selectedReportId,
                roleIds: roleIds
            });
            if(res2.isOk) {
                res2.data.data.forEach(e => {
                    this.storedRoleIds.push(e.roleId);
                    this.selected.push(e.roleId);
                });
            }
        },
        async getData() {
            // state for loading overlay
            this.isBusy = true;
            let workspaceId = this.$route.query.id;

            // get reports by workspaceId
            let res = await this.getActiveReportByWorkspaceId(workspaceId);
            if(res.isOk) {
                this.reportOptions = res.data.data;
                this.selectedReportId = this.reportOptions[0].id;
            }

            // get roles
            let res1 = await this.getAllRole();
            if(res1.isOk) {
                this.items = res1.data.data;
            }

            await this.getRoleReport();

            this.isBusy = false;
        },        

        // function select item in table
        async selectRow(id) {
            if (this.selected.includes(id)) {
                // this.selected.splice(this.selected.indexOf(id), 1);
                this.selected = this.selected.filter(e => e !== id);
            }
            else {
                this.selected.push(id);
            }
            this.createRoleIds = this.selected.filter(e => !this.storedRoleIds.includes(e));
            this.deleteRoleIds = this.storedRoleIds.filter(e => !this.selected.includes(e));
        },
        async selectAllRows(e) {
            if (e.target.checked) {
                this.selected = this.items.map((item) =>  item.id);
            }
            else {
                this.selected = [];
            }
            this.createRoleIds = this.selected.filter(e => !this.storedRoleIds.includes(e));
            this.deleteRoleIds = this.storedRoleIds.filter(e => !this.selected.includes(e));
        },


        // ------ show/hide delete confirm ------
        async showConfirmModal(id) {
            this.selectedId = id;
            $('#confirmModal').modal('show');
        },
        async hideConfirmModal() {
            $('#confirmModal').modal('hide'); 
        },
        

        // ------ create, update submit ------
        async onSubmit() {
            this.submitted = true;
            // delete data
            await this.deleteByReportIdAndRoleIds({
                reportId: this.selectedReportId,
                roleIds: this.deleteRoleIds
            });

            await this.createRoleReportMultiple({
                reportId: this.selectedReportId,
                roleIds: this.createRoleIds
            });

            window.location.reload();

            // this.hideConfirmModal();
            // this.submitted = false;
        },

        
    },
    async mounted() {
        // setup title header
        await this.setup();
        // get data table
        await this.getData();
    },
    async created() {

    }
}
</script>

<style>

</style>
